import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

//import { getParties } from './party';


export const LOADING_USERS = () => ({ type: 'LOADING_USERS', });
export const LOADING_USERS_SUCCESS = () => ({ type: 'LOADING_USERS_SUCCESS', });
export const LOADING_USERS_ERROR = () => ({ type: 'LOADING_USERS_ERROR', });

export const ADDING_USER = () => ({ type: 'ADDING_USER', });
export const ADDING_USER_SUCCESS = () => ({ type: 'ADDING_USER_SUCCESS', });
export const ADDING_USER_ERROR = () => ({ type: 'ADDING_USER_ERROR', });

export const UPDATING_USER = () => ({ type: 'UPDATING_USER', });
export const UPDATING_USER_SUCCESS = () => ({ type: 'UPDATING_USER_SUCCESS', });
export const UPDATING_USER_ERROR = () => ({ type: 'UPDATING_USER_ERROR', });

export const DELETING_USER = () => ({ type: 'DELETING_USER', });
export const DELETING_USER_SUCCESS = () => ({ type: 'DELETING_USER_SUCCESS', });
export const DELETING_USER_ERROR = () => ({ type: 'DELETING_USER_ERROR', });

export const FINDING_USER = () => ({ type: 'FINDING_USER', });
export const FINDING_USER_SUCCESS = () => ({ type: 'FINDING_USER_SUCCESS', });
export const FINDING_USER_ERROR = () => ({ type: 'FINDING_USER_ERROR', });




export const LOADING_AREAS = () => ({ type: 'LOADING_AREAS', });
export const LOADING_AREAS_SUCCESS = () => ({ type: 'LOADING_AREAS_SUCCESS', });
export const LOADING_AREAS_ERROR = () => ({ type: 'LOADING_AREAS_ERROR', });

export const ADDING_AREA = () => ({ type: 'ADDING_AREA', });
export const ADDING_AREA_SUCCESS = () => ({ type: 'ADDING_AREA_SUCCESS', });
export const ADDING_AREA_ERROR = () => ({ type: 'ADDING_AREA_ERROR', });

export const UPDATING_AREA = () => ({ type: 'UPDATING_AREA', });
export const UPDATING_AREA_SUCCESS = () => ({ type: 'UPDATING_AREA_SUCCESS', });
export const UPDATING_AREA_ERROR = () => ({ type: 'UPDATING_AREA_ERROR', });

export const DELETING_AREA = () => ({ type: 'DELETING_AREA', });
export const DELETING_AREA_SUCCESS = () => ({ type: 'DELETING_AREA_SUCCESS', });
export const DELETING_AREA_ERROR = () => ({ type: 'DELETING_AREA_ERROR', });

export const FINDING_AREA = () => ({ type: 'FINDING_AREA', });
export const FINDING_AREA_SUCCESS = () => ({ type: 'FINDING_AREA_SUCCESS', });
export const FINDING_AREA_ERROR = () => ({ type: 'FINDING_AREA_ERROR', });




export const LOADING_GROUPS = () => ({ type: 'LOADING_GROUPS', });
export const LOADING_GROUPS_SUCCESS = () => ({ type: 'LOADING_GROUPS_SUCCESS', });
export const LOADING_GROUPS_ERROR = () => ({ type: 'LOADING_GROUPS_ERROR', });

export const ADDING_GROUP = () => ({ type: 'ADDING_GROUP', });
export const ADDING_GROUP_SUCCESS = () => ({ type: 'ADDING_GROUP_SUCCESS', });
export const ADDING_GROUP_ERROR = () => ({ type: 'ADDING_GROUP_ERROR', });

export const UPDATING_GROUP = () => ({ type: 'UPDATING_GROUP', });
export const UPDATING_GROUP_SUCCESS = () => ({ type: 'UPDATING_GROUP_SUCCESS', });
export const UPDATING_GROUP_ERROR = () => ({ type: 'UPDATING_GROUP_ERROR', });

export const DELETING_GROUP = () => ({ type: 'DELETING_GROUP', });
export const DELETING_GROUP_SUCCESS = () => ({ type: 'DELETING_GROUP_SUCCESS', });
export const DELETING_GROUP_ERROR = () => ({ type: 'DELETING_GROUP_ERROR', });

export const FINDING_GROUP = () => ({ type: 'FINDING_GROUP', });
export const FINDING_GROUP_SUCCESS = () => ({ type: 'FINDING_GROUP_SUCCESS', });
export const FINDING_GROUP_ERROR = () => ({ type: 'FINDING_GROUP_ERROR', });



export const LOADING_RULES = () => ({ type: 'LOADING_RULES', });
export const LOADING_RULES_SUCCESS = () => ({ type: 'LOADING_RULES_SUCCESS', });
export const LOADING_RULES_ERROR = () => ({ type: 'LOADING_RULES_ERROR', });

export const ADDING_RULE = () => ({ type: 'ADDING_RULE', });
export const ADDING_RULE_SUCCESS = () => ({ type: 'ADDING_RULE_SUCCESS', });
export const ADDING_RULE_ERROR = () => ({ type: 'ADDING_RULE_ERROR', });

export const UPDATING_RULE = () => ({ type: 'UPDATING_RULE', });
export const UPDATING_RULE_SUCCESS = () => ({ type: 'UPDATING_RULE_SUCCESS', });
export const UPDATING_RULE_ERROR = () => ({ type: 'UPDATING_RULE_ERROR', });

export const DELETING_RULE = () => ({ type: 'DELETING_RULE', });
export const DELETING_RULE_SUCCESS = () => ({ type: 'DELETING_RULE_SUCCESS', });
export const DELETING_RULE_ERROR = () => ({ type: 'DELETING_RULE_ERROR', });



export const getUsers = (dispatch) => {
  dispatch({ type: LOADING_USERS });

  axios
    .get(`${serverURI}/api/manage/user/all`)
    .then((res) => {
      dispatch({
        type: LOADING_USERS_SUCCESS,
        payload: res.data.users
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_USERS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addUser = (user, dispatch) => {
  dispatch({ type: ADDING_USER });

  //console.log('add user ->');
  //console.log(user);

  axios
    .post(`${serverURI}/api/manage/user/add`, user)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_USER_SUCCESS, 
        payload: res.data.user, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_USER_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateUser = (id, user, dispatch) => {
  dispatch({ type: UPDATING_USER });

  axios
    .put(`${serverURI}/api/manage/user/update/${id}`, user)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_USER_SUCCESS, 
        payload: res.data.user, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_USER_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteUser = (deletes, dispatch) => {
  dispatch({ type: DELETING_USER });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/manage/user/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_USER_SUCCESS, 
        payload: res.data.deletedUsers, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_USER_ERROR, payload: err });
      errorHandler(err);
    });
};


export const findUser = (find, dispatch) => {
  dispatch({ type: FINDING_USER });

  axios
    .post(`${serverURI}/api/manage/user/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_USER_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_users: res.data.users, 
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_USER_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeUser = (dispatch) => {
  dispatch({ type: FINDING_USER_SUCCESS, 
    payload: {
      find_total: 0,
      find_users: [], 
    }
  });
};







export const getAreas = (dispatch) => {
  dispatch({ type: LOADING_AREAS });

  axios
    .get(`${serverURI}/api/manage/area/all`)
    .then((res) => {
      dispatch({
        type: LOADING_AREAS_SUCCESS,
        payload: res.data.areas
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_AREAS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addArea = (area, dispatch) => {
  dispatch({ type: ADDING_AREA });

  axios
    .post(`${serverURI}/api/manage/area/add`, area)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_AREA_SUCCESS, 
        payload: res.data.area, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_AREA_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateArea = (id, area, dispatch) => {
  dispatch({ type: UPDATING_AREA });

  axios
    .put(`${serverURI}/api/manage/area/update/${id}`, area)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_AREA_SUCCESS, 
        payload: res.data.area, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_AREA_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteArea = (deletes, dispatch) => {
  dispatch({ type: DELETING_AREA });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/manage/area/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_AREA_SUCCESS, 
        payload: res.data.deletedAreas, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_AREA_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findArea = (find, dispatch) => {
  dispatch({ type: FINDING_AREA });

  axios
    .post(`${serverURI}/api/manage/area/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_AREA_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_areas: res.data.areas, 
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_AREA_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeArea = (dispatch) => {
  dispatch({ type: FINDING_AREA_SUCCESS, 
    payload: {
      find_total: 0,
      find_areas: [], 
    }
  });
};





export const getGroups = (dispatch) => {
  dispatch({ type: LOADING_GROUPS });

  axios
    .get(`${serverURI}/api/manage/group/all`)
    .then((res) => {
      dispatch({
        type: LOADING_GROUPS_SUCCESS,
        payload: res.data.groups
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_GROUPS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addGroup = (group, dispatch) => {
  dispatch({ type: ADDING_GROUP });

  axios
    .post(`${serverURI}/api/manage/group/add`, group)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_GROUP_SUCCESS, 
        payload: res.data.group, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_GROUP_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateGroup = (id, group, dispatch) => {
  dispatch({ type: UPDATING_GROUP });

  axios
    .put(`${serverURI}/api/manage/group/update/${id}`, group)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_GROUP_SUCCESS, 
        payload: res.data.group, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_GROUP_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteGroup = (deletes, dispatch) => {
  dispatch({ type: DELETING_GROUP });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/manage/group/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_GROUP_SUCCESS, 
        payload: res.data.deletedGroups, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_GROUP_ERROR, payload: err });
      errorHandler(err);
    });
};

export const findGroup = (find, dispatch) => {
  dispatch({ type: FINDING_GROUP });

  axios
    .post(`${serverURI}/api/manage/group/find`, find)
    .then((res) => {
      //console.log(res);
      dispatch({ type: FINDING_GROUP_SUCCESS, 
        payload: {
          find_total: res.data.total,
          find_groups: res.data.groups, 
        }
      });
    })
    .catch((err) => {
      dispatch({ type: FINDING_GROUP_ERROR, payload: err });
      errorHandler(err);
    });
};

export const removeGroup = (dispatch) => {
  dispatch({ type: FINDING_GROUP_SUCCESS, 
    payload: {
      find_total: 0,
      find_groups: [], 
    }
  });
};





export const getRules = (dispatch) => {
  dispatch({ type: LOADING_RULES });

  axios
    .get(`${serverURI}/api/manage/rule/all`)
    .then((res) => {
      dispatch({
        type: LOADING_RULES_SUCCESS,
        payload: res.data.rules
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_RULES_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addRule = (rule, dispatch) => {
  dispatch({ type: ADDING_RULE });

  axios
    .post(`${serverURI}/api/manage/rule/add`, rule)
    .then((res) => {
      //console.log(res);
      dispatch({ type: ADDING_RULE_SUCCESS, 
        payload: res.data.rule, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_RULE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateRule = (id, rule, dispatch) => {
  dispatch({ type: UPDATING_RULE });

  axios
    .put(`${serverURI}/api/manage/rule/update/${id}`, rule)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_RULE_SUCCESS, 
        payload: res.data.rule, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_RULE_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteRule = (deletes, dispatch) => {
  dispatch({ type: DELETING_RULE });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/manage/rule/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_RULE_SUCCESS, 
        payload: res.data.deletedRules, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_RULE_ERROR, payload: err });
      errorHandler(err);
    });
};
